import { Box } from '@stereograph/teia-system-design/components/Box';
import {
  DocumentViewer,
  DocumentViewerProps,
} from '@stereograph/teia-system-design/components/DocumentViewer';
import { Stack } from '@stereograph/teia-system-design/components/Stack';
import {
  StandardWidget,
  StandardWidgetOptions,
  TeiaViewer,
  WidgetFactoryFunction,
} from '@stereograph/teiaviewer';

declare global {
  interface ViewerWidgetRegistry {
    DocumentViewer: WidgetFactoryFunction<
      DocumentViewerWidget,
      {
        documentViewerProps: DocumentViewerProps;
        title: string;
      } & StandardWidgetOptions
    >;
  }
}

export interface DocumentViewerWidgetProps {
  documentViewerProps: DocumentViewerProps;
  title: string;
}

export class DocumentViewerWidget extends StandardWidget {
  readonly type = 'DocumentViewer';
  documentViewerProps: DocumentViewerProps;
  title: string;

  constructor(
    viewer: TeiaViewer,
    documentViewerProps: DocumentViewerProps,
    title: string,
    options: StandardWidgetOptions = {},
  ) {
    super(viewer, {
      ...options,
      color: 'white',
      useFooter: false,
    });

    this.documentViewerProps = documentViewerProps;
    this.title = title;
  }

  override Header = () => {
    return <Stack alignItems="center">{this.title}</Stack>;
  };

  override Content = () => {
    const { imageViewerProps, ...rest } = this.documentViewerProps;
    const { style: imageViewerStyle, ...restImageViewerProps } = imageViewerProps ?? {};

    return (
      <Box sx={{
        p: 3,
        height: '100%',
      }}
      >
        <DocumentViewer
          {...rest}
          imageViewerProps={{
            style: {
              height: '100%',
              width: '100%',
              maxHeight: '100%',
              maxWidth: '100%',
              objectFit: 'contain',
              ...imageViewerStyle,
            },
            ...restImageViewerProps,
          }}
        />
      </Box>
    );
  };
}
